export const MENU_ELEMENT_ID = 'tv2-menu';
export const MENU_TOP_NAV_ELEMENT_ID = 'tv2-menu-top-nav';
export const MENU_MEGAMENU_TOGGLE_ELEMENT_ID = 'tv2-menu-mega-menu-toggle';
export const MENU_ELEMENT_CLASS_MOBILE_CATEGORIES_HIDDEN = 'tv2-menu--disable-mobile-top-menu-categories';
export const MENU_ELEMENT_CLASS_MINIMIZED = 'tv2-menu--minimized';
